import axios from 'axios';
import apiConfig from '../Config';

// Create axios instance with base configuration
const apiClient = axios.create({
  baseURL: apiConfig.apiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add token to all requests
apiClient.interceptors.request.use(
  (config) => {
    // Get token from sessionStorage
    const savedUser = sessionStorage.getItem('iti_company_user');
    let token = null;
    if (savedUser) {
      try {
        const user = JSON.parse(savedUser);
        token = user.iti_active_token;
      } catch (e) {
        console.error("Failed to parse user from session storage in api client", e);
      }
    }

    // Add token to Authorization header if it exists
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default apiClient;

